var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"d-flex align-stretch"},[_c('v-col',{attrs:{"cols":"12","lg":"4","xl":"4"}},[_c('Quickstart')],1),_c('v-col',{attrs:{"cols":"12","lg":"4","xl":"4"}},[_c('GraphNewUsers')],1),_c('v-col',{attrs:{"cols":"12","lg":"4","xl":"4"}},[_c('GraphSales')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }